module.exports = __webpack_public_path__ + "static/media/homepic.b58045a9.png";